import {
    ADMIN_CREATE_ACTIVITY_FAILURE,
    ADMIN_CREATE_ACTIVITY_REQUEST,
    ADMIN_CREATE_ACTIVITY_SUCCESS,
    ADMIN_CREATE_USER_FAILURE,
    ADMIN_CREATE_USER_REQUEST,
    ADMIN_CREATE_USER_SUCCESS,
    ADMIN_GET_ACTIVITIES_FAILURE,
    ADMIN_GET_ACTIVITIES_REQUEST,
    ADMIN_GET_ACTIVITIES_SUCCESS,
    ADMIN_GET_PERMISSIONS_FAILURE,
    ADMIN_GET_PERMISSIONS_REQUEST,
    ADMIN_GET_PERMISSIONS_SUCCESS,
    ADMIN_GET_USERS_FAILURE,
    ADMIN_GET_USERS_REQUEST,
    ADMIN_GET_USERS_SUCCESS,
    ADMIN_SAVE_ACTIVITY_FAILURE,
    ADMIN_SAVE_ACTIVITY_REQUEST,
    ADMIN_SAVE_ACTIVITY_SUCCESS,
    ADMIN_SAVE_USER_FAILURE,
    ADMIN_SAVE_USER_REQUEST,
    ADMIN_SAVE_USER_SUCCESS,
} from "./actions";
import { LOGOUT } from "../../../data/user/actions";

const initialState = {
    isLoading: false,
    users: [],
    activities: [],
    permissions: []
};

// -----------------------------------------------------------------------------
// REDUCER

export default (state = initialState, action) => {

    switch (action.type) {

        case ADMIN_GET_USERS_REQUEST:
        case ADMIN_SAVE_USER_REQUEST:
        case ADMIN_CREATE_USER_REQUEST:

            return {
                ...state,
                isLoading: true,
            };

        case ADMIN_CREATE_USER_SUCCESS:
        case ADMIN_CREATE_USER_FAILURE:
        case ADMIN_SAVE_USER_FAILURE:
        case ADMIN_SAVE_USER_SUCCESS:
        case ADMIN_GET_USERS_FAILURE:

            return {
                ...state,
                isLoading: false,
            };

        case ADMIN_GET_USERS_SUCCESS:

            return {
                ...state,
                users: action.data.data,
                isLoading: false,
            };

        case ADMIN_GET_ACTIVITIES_REQUEST:
        case ADMIN_SAVE_ACTIVITY_REQUEST:
        case ADMIN_CREATE_ACTIVITY_REQUEST:
        case ADMIN_GET_PERMISSIONS_REQUEST:

            return {
                ...state,
                isLoading: true,
            };
        case ADMIN_CREATE_ACTIVITY_SUCCESS:
        case ADMIN_CREATE_ACTIVITY_FAILURE:
        case ADMIN_SAVE_ACTIVITY_FAILURE:
        case ADMIN_SAVE_ACTIVITY_SUCCESS:
        case ADMIN_GET_ACTIVITIES_FAILURE:
        case ADMIN_GET_PERMISSIONS_FAILURE:

            return {
                ...state,
                isLoading: false,
            };

        case ADMIN_GET_ACTIVITIES_SUCCESS:


            return {
                ...state,
                activities: action.activities,
                isLoading: false,
            };
        case ADMIN_GET_PERMISSIONS_SUCCESS:


            return {
                ...state,
                permissions: action.permissions,
                isLoading: false,
            };

        case LOGOUT:
            return initialState;

        default:
            return state

    }
}
// -----------------------------------------------------------------------------
// PRIVATE SELECTORS

export function getActivities(store) {
    return store.activities
}

export function getUsers(store) {
    return store.users
}

export function getPermissions(store) {
    return store.permissions;
}



// WEBPACK FOOTER //
// ./src/scenes/Admin/reducer/index.js